import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader-full-screen',
  templateUrl: './loader-full-screen.component.html',
  styleUrls: ['./loader-full-screen.component.scss'],
})
export class LoaderFullScreenComponent {
  @Input() message? = '';
}
